var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrePostSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.38 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #e11e24;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-1",
    d: "M6,4.17v2.8c0,.37.28.66.65.67h0c.37,0,.66-.3.65-.67h0v-2.8c0-.36-.28-.66-.65-.67h0c-.36,0-.65.31-.65.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    className: "cls-1",
    d: "M7.3,8.67c0,.36-.29.65-.65.65s-.65-.29-.65-.65.29-.65.65-.65.65.29.65.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.7,10.66H1.3L6.5,1.34l1.71,3.06V1.71l-.58-1.04c-.12-.22-.3-.4-.52-.52-.62-.33-1.39-.1-1.73.52L.17,9.99c-.23.42-.23.92,0,1.34.23.41.66.66,1.12.67h10.4c.47,0,.9-.26,1.12-.67.23-.42.23-.92,0-1.34l-.63-1.13-1.16.62.66,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.11,9.82c-.09,0-.18-.02-.26-.07-.15-.09-.24-.25-.24-.43V1.3c0-.17.09-.34.24-.43s.33-.1.49-.02l7.76,4.01c.17.09.27.26.27.44s-.1.36-.27.44l-7.76,4.01c-.07.04-.15.06-.23.06ZM9.61,2.12v6.38l6.17-3.19-6.17-3.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.38 5.31 10.86 4.01 10.86 6.62 13.38 5.31"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrePostSelected);
export default __webpack_public_path__ + "static/media/Pre-Post-Selected.29976907c1a2821a9df8da503b565876.svg";
export { ForwardRef as ReactComponent };